(function () {
function init(host) {
var SID = host.getAttribute('data-sid');
var tpl = document.getElementById('fitl-tpl-' + SID);
var dataEl = document.getElementById('fitl-data-' + SID);
if (!tpl || !dataEl || host.shadowRoot) return;
var DATA = JSON.parse(dataEl.textContent);
var root = host.attachShadow({ mode: 'open' });
root.appendChild(tpl.content.cloneNode(true));
var $ = function (id) { return root.getElementById(id); };
var QA = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var wideMq = window.matchMedia('(min-width: 820px)');
var P = DATA.product, GUIDE = DATA.guide || [], SIZING = DATA.sizing || {};
var NAME = DATA.shortName;
function track(name, data) {
data = Object.assign({ product: P.handle, template: 'fit-landing-single' }, data || {});
try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
try { if (window.fbq) window.fbq('trackCustom', name, data); } catch (e) {}
try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
}
var taggedCart = false;
function tagCartWatched() {
if (taggedCart) return; taggedCart = true;
fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ attributes: { 'Watched fit video': 'yes', 'Fit video product': P.handle } })
}).catch(function () { taggedCart = false; });
}
var V = {}, SIZES = [];
var ONE = (GUIDE[0] && GUIDE[0].inseam) || 'one';
P.variants.forEach(function (x) {
var size = x.option2 || x.option1;
if (!size) return;
V[ONE + '|' + size] = { id: x.id, available: !!x.available };
if (SIZES.indexOf(size) < 0) SIZES.push(size);
});
if (!GUIDE.length && P.options && P.options.length > 1) {
P.variants.forEach(function (x) {
var len = String(x.option1 || '').replace(/[^0-9]/g, '');
if (len && !GUIDE.some(function (g) { return g.inseam === len; })) GUIDE.push({ inseam: len, name: len + '"', max_height_in: 99 });
});
}
var isW = function (s) { return /W$/i.test(s); };
function sKey(s) { var n = parseInt(s, 10) || 0; return /W$/i.test(s) ? 1000 + n : n; }
SIZES.sort(function (a, b) { return sKey(a) - sKey(b); });
var BYID = {};
Object.keys(V).forEach(function (k) { BYID[V[k].id] = V[k]; });
var stockAt = 0;
function refreshStock() {
stockAt = Date.now();
var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
return fetch(base + 'products/' + P.handle + '.js?_=' + stockAt, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
.then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
.then(function (p) { (p.variants || []).forEach(function (x) { if (BYID[x.id]) BYID[x.id].available = !!x.available; }); render(); })
.catch(function () {});
}
var LEVIS = SIZES.filter(function (s) { return s.indexOf('/') > 0; }).map(function (s) { return s.split('/')[0]; });
var JB = SIZES.map(function (s) { return s.indexOf('/') > 0 ? s.split('/')[1] : s; });
var price = P.price / 100;
var money = function (n) { return '$' + (n % 1 ? n.toFixed(2) : String(n)); };
var state = { len: ONE, size: '' };
var height = $('height'), brand = $('brand'), usual = $('usual'), grid = $('sizeGrid'), helpBtn = $('helpBtn'), helper = $('helper'), usedHelper = false;
var addBtn = $('addBtn'), cartMsg = $('cartMsg');
for (var h = 56; h <= 74; h++) {
var o = document.createElement('option');
o.value = h; o.textContent = Math.floor(h / 12) + "'" + (h % 12) + '"';
height.appendChild(o);
}
var reg = SIZES.filter(function (s) { return !isW(s); }), curvy = SIZES.filter(isW);
[reg, curvy].forEach(function (list) {
if (!list.length) return;
var g = document.createElement('div'); g.className = 'sizes'; g.setAttribute('role', 'group'); g.setAttribute('aria-labelledby', 'size-label');
list.forEach(function (s) {
var b = document.createElement('button'), parts = s.split('/');
b.type = 'button'; b.dataset.size = s; b.setAttribute('aria-pressed', 'false');
b.innerHTML = '<b></b>' + (parts.length > 1 ? '<small></small>' : '');
b.firstChild.textContent = parts.length > 1 ? parts[1] : s;
if (parts.length > 1) b.lastChild.textContent = 'waist ' + parts[0];
b.setAttribute('aria-label', 'Size ' + (parts.length > 1 ? parts[1] + ', waist ' + parts[0] : s));
b.addEventListener('click', function () { state.size = s; cartMsg.dataset.kind = ''; render(); });
g.appendChild(b);
});
grid.parentNode.insertBefore(g, grid);
});
grid.parentNode.removeChild(grid);
function fillUsual() {
usual.innerHTML = '';
var first = document.createElement('option'); first.value = ''; first.textContent = 'Your size'; usual.appendChild(first);
var list = brand.value === 'levis' ? LEVIS : brand.value === 'jb' ? JB : SIZES;
list.forEach(function (s) { var o = document.createElement('option'); o.value = s; o.textContent = s; usual.appendChild(o); });
}
function lenFor(inches) {
for (var i = 0; i < GUIDE.length; i++) if (inches <= (GUIDE[i].max_height_in || 99)) return GUIDE[i].inseam;
return GUIDE.length ? GUIDE[GUIDE.length - 1].inseam : '';
}
function lenName(l) { var g = GUIDE.filter(function (x) { return x.inseam === l; })[0]; return g ? g.name : l + '"'; }
function variant(len, size) { return V[len + '|' + size]; }
function shift(idx, off) {
var t = idx + (off || 0);
if (idx < 0 || t < 0 || t >= SIZES.length || isW(SIZES[idx]) !== isW(SIZES[t])) return null;
return SIZES[t];
}
function sizeFor() {
var v = usual.value; if (!v) return { size: '', why: '' };
var fallback = { size: '', why: 'For this size, our full Find My Size tool or our team will match you best.' };
if (brand.value === 'levis') {
var off = SIZING.levis_offset || 0;
var s = shift(SIZES.indexOf(SIZES.filter(function (x) { return x.split('/')[0] === v; })[0]), off);
if (!s) return fallback;
return { size: s, why: "You wear " + v + " in Levi's, so choose " + s + (off === 0 ? ". The " + NAME + " is true to size." : off > 0 ? ". Most women size up " + off + " in the " + NAME + "." : ". Most women size down " + (-off) + " in the " + NAME + ".") };
}
if (brand.value === 'jb') {
var joff = SIZING.judy_blue_offset || 0;
var j = shift(JB.indexOf(v), joff);
if (!j) return fallback;
return { size: j, why: (joff > 0 ? 'Most women size up ' + joff + ' from Judy Blue. ' : joff < 0 ? 'Most women size down ' + (-joff) + ' from Judy Blue. ' : '') + 'You wear ' + v + ', so choose ' + j + '.' };
}
return { size: v, why: 'Choose the same size you wear in Ava Lane.' };
}
var finderTracked = false;
function render() {
var v = state.len && state.size ? variant(state.len, state.size) : null;
var ready = !!(v && v.available);
QA('#lenSeg button').forEach(function (b) {
b.setAttribute('aria-pressed', b.dataset.len === state.len ? 'true' : 'false');
var bv = state.size ? variant(b.dataset.len, state.size) : null;
b.dataset.sold = (bv && !bv.available) ? 'true' : 'false';
});
QA('.sizes button').forEach(function (b) {
var s = b.dataset.size, sold;
if (state.len) { var ov = variant(state.len, s); sold = !!(ov && !ov.available); }
else sold = GUIDE.every(function (g) { var gv = variant(g.inseam, s); return !gv || !gv.available; });
b.dataset.sold = sold ? 'true' : 'false';
b.setAttribute('aria-pressed', s === state.size ? 'true' : 'false');
b.setAttribute('aria-label', b.getAttribute('aria-label').replace(/ \(sold out\)$/, '') + (sold ? ' (sold out)' : ''));
});
var big = $('res-big');
if (state.len && state.size) big.textContent = 'Your ' + NAME + ': size ' + state.size + ', ' + lenName(state.len) + ' ' + state.len + '"';
else if (!state.size) big.textContent = 'Your ' + NAME + ': tell us the jeans you wear now';

var lh = root.querySelector('.lenhint'); if (lh) lh.style.color = height.value ? 'var(--ink)' : '';
var soldOut = !!(v && !v.available);
addBtn.disabled = !ready;
addBtn.hidden = soldOut;
bis.hidden = !soldOut;
if (soldOut && bisShown !== v.id) { bisShown = v.id; bis.classList.remove('done'); bisSay(''); $('bisTitle').textContent = 'The ' + NAME + ' in ' + vLabel() + ' is sold out right now'; $('bisSub').textContent = "Get an alert when it's back, or try another " + (GUIDE.length > 1 ? 'length or size.' : 'size.'); }
if (ready) addBtn.textContent = 'Add to Cart · ' + state.size + ', ' + lenName(state.len);
else if (v) addBtn.textContent = 'Sold out in ' + state.size + ', ' + lenName(state.len);
else if (state.size && !state.len) addBtn.textContent = 'Choose your length';
else if (state.len && !state.size) addBtn.textContent = 'Choose your size';
else addBtn.textContent = 'Add to Cart · ' + money(price);
if (soldOut && cartMsg.dataset.kind !== 'error') cartMsg.textContent = '';
else if (cartMsg.dataset.kind !== 'error') cartMsg.textContent = '';
$('st-title').textContent = ready ? 'Size ' + state.size + ', ' + lenName(state.len) + ' ' + state.len + '"' : 'The ' + NAME + ', ' + money(price);
$('st-sub').textContent = ready ? money(price) + ' · 30-day easy returns' : '30-day easy returns';
$('st-btn').textContent = ready ? 'Add to Cart' : soldOut ? 'Notify Me' : 'Find My Size';
if (ready && !finderTracked) { finderTracked = true; track('fit_size_selected', { size: state.size, inseam: state.len, method: usedHelper ? 'finder' : 'direct' }); }
}
function addToCart() {
var v = state.len && state.size ? variant(state.len, state.size) : null;
if (!v || !v.available) { goTo('size'); return; }
addBtn.disabled = true; addBtn.textContent = 'Adding…';
cartMsg.dataset.kind = ''; cartMsg.textContent = '';
var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
var fd = new FormData();
fd.append('id', v.id); fd.append('quantity', 1);
if (cart && cart.getSectionsToRender) {
fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
fd.append('sections_url', window.location.pathname);
if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
}
var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
.then(function (r) { return r.json(); })
.then(function (res) {
if (res.status) throw new Error(res.description || 'We could not add that size.');
track('fit_add_to_cart', { size: state.size, inseam: state.len, variant: v.id, watched_video: taggedCart });
if (cart && cart.renderContents) { cart.renderContents(res); cart.classList.remove('is-empty'); render(); }
else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
})
.catch(function (err) {
cartMsg.dataset.kind = 'error';
cartMsg.textContent = err.message + ' Please try again, or choose another size.';
render(); refreshStock();
});
}

brand.addEventListener('change', function () { fillUsual(); render(); });
usual.addEventListener('change', function () { var r = sizeFor(); if (r.size) state.size = r.size; if (r.why) $('res-why').textContent = r.why; cartMsg.dataset.kind = ''; render(); });
helpBtn.addEventListener('click', function () {
var open = helper.hidden; helper.hidden = !open; helpBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
$('helpTxt').textContent = open ? 'Hide the size finder' : "Not sure of your size? We'll find it in 20 seconds";
if (open) { usedHelper = true; track('fit_size_helper_open'); (height.hidden ? brand : height).focus(); }
});
QA('#lenSeg button').forEach(function (b) { b.addEventListener('click', function () { state.len = b.dataset.len; cartMsg.dataset.kind = ''; render(); }); });
addBtn.addEventListener('click', addToCart);
$('st-btn').addEventListener('click', function () { if (addBtn.disabled) goTo('size'); else addToCart(); });
var bis = $('bis'), bisEmail = $('bisEmail'), bisPhone = $('bisPhone'), bisBtn = $('bisBtn'), bisMsg = $('bisMsg'), bisShown = null;
var BIS = DATA.bis || {};
function vLabel() { return 'size ' + state.size + (GUIDE.length > 1 ? ', ' + lenName(state.len) + ' ' + state.len + '"' : ''); }
function bisSay(t, err) { bisMsg.dataset.kind = err ? 'error' : ''; bisMsg.textContent = t; }
function e164(s) { var d = s.replace(/\D/g, ''); if (d.length === 10) return '+1' + d; if (d.length === 11 && d.charAt(0) === '1') return '+' + d; return ''; }
function kPost(path, body) {
return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(BIS.key || ''), {
method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(body)
}).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
}
bis.addEventListener('submit', function (ev) {
ev.preventDefault();
var v = state.len && state.size ? variant(state.len, state.size) : null;
if (!v || !BIS.key) return;
var email = bisEmail.value.trim(), phoneRaw = bisPhone.value.trim(), phone = phoneRaw ? e164(phoneRaw) : '';
if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { bisSay('Please enter a valid email.', true); bisEmail.focus(); return; }
if (phoneRaw && !phone) { bisSay('Please enter a 10-digit US mobile number, or leave it blank.', true); bisPhone.focus(); return; }
var label = vLabel();
bisBtn.disabled = true; bisBtn.textContent = 'Saving…'; bisSay('');
var smsStep = (phone && BIS.smsList) ? kPost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Fit page back in stock', profile: { data: { type: 'profile', attributes: { phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: BIS.smsList } } } } }).then(function () { return true; }, function () { return false; }) : Promise.resolve(false);
smsStep.then(function (sms) {
var attrs = { email: email }; if (sms) attrs.phone_number = phone;
return kPost('back-in-stock-subscriptions', { data: { type: 'back-in-stock-subscription', attributes: { channels: sms ? ['EMAIL', 'SMS'] : ['EMAIL'], profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } } } }).then(function () { return sms; });
}).then(function (sms) {
bis.classList.add('done');
bisSay("You're on the list. We'll email " + (sms ? 'and text ' : '') + 'you when ' + label + ' is back.' + (phone && !sms ? ' We could not set up the text alert, so watch your email.' : ''));
track('fit_back_in_stock_signup', { size: state.size, inseam: state.len, variant: v.id, sms: sms });
}).catch(function () {
bisSay('Something went wrong. Please try again, or message our team and we will save your size.', true);
}).then(function () { bisBtn.disabled = false; bisBtn.textContent = 'Notify me'; });
});
fillUsual(); render(); refreshStock();
window.addEventListener('pageshow', function (e) { if (e.persisted) refreshStock(); });
document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && Date.now() - stockAt > 60000) refreshStock(); });
function goTo(id) { var t = $(id); if (t && t.tagName === 'DETAILS') t.open = true; if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
root.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('a[href^="#"]');
if (!a) return;
var id = a.getAttribute('href').slice(1);
if ($(id)) { e.preventDefault(); goTo(id); }
});
QA('details').forEach(function (d) {
d.addEventListener('toggle', function () { if (d.open) track('fit_faq_open', { question: d.querySelector('summary').textContent.trim() }); });
});
var ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9l4 6M21 9l-4 6"/></svg>';
var ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9a4 4 0 010 6M18.5 6.5a8 8 0 010 11"/></svg>';
var vids = QA('.vid video');
function setIcon(v, on) { var b = v.parentNode.querySelector('.sound'); b.innerHTML = on ? ICON_ON : ICON_OFF; b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); }
vids.forEach(function (v) {
setIcon(v, false);
var who = v.dataset.who || '', played = false, watched = false, seen = 0;
v.addEventListener('timeupdate', function () {
if (v.paused) return;
seen += 0.25;
if (!played && seen >= 2) { played = true; track('fit_video_play', { video: who, sound: !v.muted }); }
if (!watched && v.duration && v.currentTime / v.duration >= 0.75) { watched = true; track('fit_video_watched', { video: who, sound: !v.muted }); tagCartWatched(); }
});
function toggle() {
var turnOn = v.muted;
vids.forEach(function (o) { if (o !== v) { o.muted = true; setIcon(o, false); } });
v.muted = !turnOn; setIcon(v, turnOn);
if (turnOn) { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); track('fit_video_sound_on', { video: who }); }
}
v.parentNode.querySelector('.sound').addEventListener('click', toggle);
v.addEventListener('click', toggle);
});
if ('IntersectionObserver' in window && !reduce) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
var v = e.target;
if (e.isIntersecting && e.intersectionRatio >= 0.5) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
else { v.pause(); }
});
}, { threshold: [0, 0.5, 1] });
vids.forEach(function (v) { io.observe(v); });
}
function scroller(box, prevB, nextB, onMove) {
if (!box || !prevB || !nextB) return;
function step() { var c = box.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : box.clientWidth; }
function arrows() {
var max = box.scrollWidth - box.clientWidth;
prevB.hidden = box.scrollLeft <= 4;
nextB.hidden = max <= 4 || box.scrollLeft >= max - 4;
if (onMove) onMove(Math.round(box.scrollLeft / step()));
}
prevB.addEventListener('click', function () { box.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
nextB.addEventListener('click', function () { box.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
box.addEventListener('scroll', arrows, { passive: true });
window.addEventListener('resize', arrows);
arrows();
}
var rail = $('rail');
scroller(rail, $('railPrev'), $('railNext'));
var gal = $('gallery'), galCount = $('galCount');
scroller(gal, $('galPrev'), $('galNext'), function (i) {
var n = gal.children.length; i = Math.max(0, Math.min(n - 1, i));
galCount.textContent = n > 1 ? (i + 1) + ' / ' + n + (i === 0 ? ' · swipe to see front, side and back' : '') : '';
});
QA('.chip').forEach(function (c) {
c.addEventListener('click', function () {
var t = rail.children[+c.dataset.go];
rail.scrollTo({ left: t.offsetLeft - rail.firstElementChild.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
QA('.chip').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
});
});
var sticky = $('sticky');
var watch = [root.querySelector('.hero .ctas'), root.querySelector('.finder'), root.querySelector('.final .ctas')];
var seenEls = [true, false, false];
function upd() {
var hide = seenEls.some(Boolean);
sticky.classList.toggle('is-hidden', hide);
sticky.setAttribute('aria-hidden', hide ? 'true' : 'false');
$('st-btn').tabIndex = hide ? -1 : 0;
document.body.classList.toggle('bfp-sticky-on', !hide && !wideMq.matches);
}
if ('IntersectionObserver' in window) {
watch.forEach(function (el, i) { if (el) new IntersectionObserver(function (e) { seenEls[i] = e[0].isIntersecting; upd(); }).observe(el); });
}
}
function boot() { Array.prototype.forEach.call(document.querySelectorAll('.fitl-host'), init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
